export default class Imagem {
  constructor(id, descricao, local, data) {
    this.id = id;
    this.descricao = descricao;
    this.local = local;
    this.data = data;
  }

  update(imagem) {
    this.id = imagem.id;
    this.descricao = imagem.descricao;
    this.local = imagem.local;
    this.data = imagem.data;
  }
}
